import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import OldApp from './OldApp';
import Ended from './Ended';
import reportWebVitals from './reportWebVitals';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';

ReactDOM.render(
  <React.StrictMode>
    <CookiesProvider>
      <Router>
        <Switch>
          <Route path='/ended'>
            <Ended />
          </Route>
          <Route path='/v2'>
            <App />
          </Route>
          <Route path='/'>
            <OldApp />
          </Route>
          <Route path='/:credential'>
            <OldApp />
          </Route>
        </Switch>
      </Router>
    </CookiesProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
